import { Injectable } from '@angular/core';

/**
 * Counter-based body scroll lock. Replaces the imperative
 * `document.body.style.overflow` writes that were scattered across
 * programplan/archive/statistics — with stacked overlays (side panel +
 * clr-modal flows) a plain boolean would strand the body locked when the
 * inner surface closes first. After migration, this service must be the
 * ONLY place in src/app that touches document.body.style.overflow.
 */
@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private count = 0;

  lock(): void {
    if (++this.count === 1) {
      document.body.style.overflow = 'hidden';
    }
  }

  unlock(): void {
    if (this.count > 0 && --this.count === 0) {
      document.body.style.overflow = '';
    }
  }
}
